import {
    CREATE_COLLECTION_METHOD,
    EDIT_COLLECTION_METHOD,
    FETCH_COLLECTION_METHOD,
    DELETE_COLLECTION_METHOD,
    SET_COLLECTION_METHOD_LOADING,
    CLEAR_COLLECTION_METHOD,
    CREATE_NOTIFICATION
} from "./types";

export const createCollectionMethod = (formValues, sendRequest) => async (dispatch) => {
    const response = await sendRequest("post")({
        url: "/collection-method/",
        data: formValues,
        devPort: 5005,
    });
    dispatch({ type: CREATE_COLLECTION_METHOD, payload: response.data });
};

export const editCollectionMethod = (id, formValues, sendRequest) => async (
    dispatch
) => {
    const response = await sendRequest("put")({
        url: `/collection-method/${id}`,
        data: { ...formValues },
        devPort: 5005,
    });
    dispatch({ type: EDIT_COLLECTION_METHOD, payload: response.data });
};

export const fetchCollectionMethod = (queryParams, sendRequest) => async (
    dispatch
) => {
    dispatch({ type: SET_COLLECTION_METHOD_LOADING, payload: true });
    let response
    try {
        response = await sendRequest("get")({
            url: "/collection-method/",
            params: queryParams,
            devPort: 5005,
        });
    } catch (err) {
        if ((err?.response?.status === 500) && (err?.response?.data?.message === 'Collection method could not be found')) {
            response = { data: {} }
        } else {
            console.error(err)
            dispatch({ type: CLEAR_COLLECTION_METHOD });
        }
    } finally {
        if (response) {
            dispatch({ type: FETCH_COLLECTION_METHOD, payload: response.data });
        }
        dispatch({ type: SET_COLLECTION_METHOD_LOADING, payload: false });
    }
};

export const deleteCollectionMethod = (id, sendRequest) => async (dispatch) => {
    // eslint-disable-next-line no-unused-vars
    try {
        await sendRequest("delete")({
            url: `/collection-method/${id}`,
            devPort: 5005,
        });
        dispatch({ type: DELETE_COLLECTION_METHOD, payload: id });
    } catch (err) {
        const msg = 'Collection Details could not be deleted'
        let errMsg = err.response.data.message
        if (errMsg?.indexOf(msg) !== -1) {
            dispatch({
                type: CREATE_NOTIFICATION,
                payload: {
                    id: Date.now(),
                    message: msg + ": collection method is being used" + errMsg?.slice(msg.length),
                    severity: "error",
                    anchor: { vertical: "top", horizontal: "center" },
                },
            });
        }
    }
};
